import {Component, OnInit} from '@angular/core';
import {AppConfig} from '../app.config';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styles: []
})
export class FooterComponent implements OnInit {

    public socialList: any = {};

    constructor() {
        AppConfig.instance.getConfig(link => {
            this.socialList = link;
        });
    }

    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// /home3/usalinks/public_html/ally-book-source/src/app/footer/footer.component.ts